module.exports = __webpack_public_path__ + "img/Business Person 1.0d970b70.jpg";